// import { useState, useEffect } from "react";
// import {
//   Building2, Plus, ToggleLeft, ToggleRight,
//   Copy, Check, RefreshCw, ChevronDown, ChevronUp, X, Pencil, AlertTriangle, RotateCcw
// } from "lucide-react";
// import DashboardLayout from "../../../components/DashboardLayout";
// import { LayoutDashboard, Users, Key, ScrollText } from "lucide-react";
// import { supabase } from "../../../lib/supabaseClient";

// const NAV = [
//   { label: "Dashboard",     icon: LayoutDashboard, path: "/admin/dashboard" },
//   { label: "Properties",    icon: Building2,        path: "/admin/properties" },
//   { label: "Users",         icon: Users,            path: "/admin/users" },
//   { label: "Valet Codes",   icon: Key,              path: "/admin/valet-codes" },
//   { label: "Activity Logs", icon: ScrollText,       path: "/admin/logs" },
// ];

// // ─── Helpers ──────────────────────────────────────────────────────────────────
// function genCode(prefix, len = 6) {
//   const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
//   let out = prefix + "-";
//   for (let i = 0; i < len; i++) out += chars[Math.floor(Math.random() * chars.length)];
//   return out;
// }

// function getToday() {
//   return new Date().toISOString().split("T")[0];
// }

// function CopyBtn({ value }) {
//   const [copied, setCopied] = useState(false);
//   const copy = () => {
//     navigator.clipboard.writeText(value);
//     setCopied(true);
//     setTimeout(() => setCopied(false), 1800);
//   };
//   return (
//     <button onClick={copy} style={{ background: "none", border: "none", cursor: "pointer", color: copied ? "var(--g600)" : "var(--mut)", padding: "2px 4px", borderRadius: 4, display: "inline-flex", alignItems: "center" }}>
//       {copied ? <Check size={13} /> : <Copy size={13} />}
//     </button>
//   );
// }

// function Badge({ active }) {
//   return (
//     <span style={{
//       fontSize: 10, fontWeight: 700, letterSpacing: ".5px", textTransform: "uppercase",
//       padding: "3px 10px", borderRadius: 20,
//       background: active ? "var(--g50)" : "#fef2f2",
//       color: active ? "var(--g600)" : "#dc2626",
//       border: `1px solid ${active ? "var(--g200)" : "#fecaca"}`,
//     }}>
//       {active ? "Active" : "Inactive"}
//     </span>
//   );
// }

// // ─── Confirm Dialog ───────────────────────────────────────────────────────────
// function ConfirmDialog({ title, message, confirmLabel, confirmColor = "#dc2626", onConfirm, onCancel }) {
//   return (
//     <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1100, padding: 16 }}>
//       <div style={{ background: "#fff", borderRadius: 14, padding: 24, width: "100%", maxWidth: 360, boxShadow: "0 8px 40px rgba(0,0,0,.16)", animation: "fadeUp .18s ease" }}>
//         <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
//           <div style={{ width: 38, height: 38, borderRadius: 10, background: "#fef2f2", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
//             <AlertTriangle size={18} color="#dc2626" />
//           </div>
//           <div style={{ fontSize: 15, fontWeight: 700, color: "var(--ink)" }}>{title}</div>
//         </div>
//         <div style={{ fontSize: 13, color: "var(--mut)", lineHeight: 1.6, marginBottom: 20 }}>{message}</div>
//         <div style={{ display: "flex", gap: 10 }}>
//           <button onClick={onCancel} style={{ flex: 1, padding: "10px", borderRadius: 9, border: "1.5px solid var(--ln)", background: "#fff", cursor: "pointer", fontSize: 13, fontWeight: 600, color: "var(--mut)" }}>Cancel</button>
//           <button onClick={onConfirm} style={{ flex: 1, padding: "10px", borderRadius: 9, border: "none", background: confirmColor, cursor: "pointer", fontSize: 13, fontWeight: 700, color: "#fff" }}>{confirmLabel}</button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ─── Property Form Modal ──────────────────────────────────────────────────────
// function PropertyModal({ existing, onClose, onSaved }) {
//   const isEdit = !!existing;

//   const [f, setF] = useState({
//     name:           existing?.name           || "",
//     address:        existing?.address        || "",
//     total_units:    existing?.total_units    || "",
//     condo_code:     existing?.condo_code     || genCode("CAN"),
//     hoa_admin_code: existing?.hoa_admin_code || genCode("HOA"),
//   });
//   const [errors,  setErrors]  = useState({});
//   const [loading, setLoading] = useState(false);
//   const [apiErr,  setApiErr]  = useState("");

//   const upd = k => v => { setF(p => ({ ...p, [k]: v })); setErrors(p => ({ ...p, [k]: "" })); };
//   const regenCondo = () => setF(p => ({ ...p, condo_code: genCode("CAN") }));
//   const regenHoa   = () => setF(p => ({ ...p, hoa_admin_code: genCode("HOA") }));

//   const validate = () => {
//     const e = {};
//     if (!f.name.trim()) e.name = "Property name required";
//     if (!f.total_units || isNaN(Number(f.total_units)) || Number(f.total_units) < 1)
//       e.total_units = "Enter a valid number of units";
//     return e;
//   };

//   const submit = async () => {
//     const e = validate();
//     if (Object.keys(e).length) { setErrors(e); return; }
//     setLoading(true); setApiErr("");

//     const payload = {
//       name:           f.name.trim(),
//       address:        f.address.trim() || null,
//       total_units:    Number(f.total_units),
//       condo_code:     f.condo_code,
//       hoa_admin_code: f.hoa_admin_code,
//       updated_at:     new Date(),
//     };

//     let error;
//     if (isEdit) {
//       ({ error } = await supabase.from("properties").update(payload).eq("id", existing.id));
//     } else {
//       ({ error } = await supabase.from("properties").insert([{ ...payload, is_active: true }]));
//     }

//     setLoading(false);
//     if (error) { setApiErr(error.message); return; }
//     onSaved(); onClose();
//   };

//   return (
//     <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.35)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 16 }}>
//       <div style={{ background: "#fff", borderRadius: 16, padding: 28, width: "100%", maxWidth: 460, boxShadow: "0 8px 40px rgba(0,0,0,.14)", animation: "fadeUp .2s ease", maxHeight: "90vh", overflowY: "auto" }}>
//         <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 22 }}>
//           <div>
//             <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "#6a1b9a", marginBottom: 4 }}>Super Admin</div>
//             <div style={{ fontSize: 17, fontWeight: 700, color: "var(--ink)" }}>{isEdit ? "Edit Property" : "Add New Property"}</div>
//           </div>
//           <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--mut)", padding: 4 }}><X size={20} /></button>
//         </div>

//         {apiErr && (
//           <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: "#dc2626", marginBottom: 16 }}>{apiErr}</div>
//         )}

//         {[
//           { key: "name",        label: "Property Name *",    placeholder: "e.g. Sunset Apartments", type: "text" },
//           { key: "address",     label: "Address (Optional)", placeholder: "123 Main St, City",      type: "text" },
//           { key: "total_units", label: "Total Units *",      placeholder: "e.g. 100",               type: "number" },
//         ].map(({ key, label, placeholder, type }) => (
//           <div key={key} style={{ marginBottom: 14 }}>
//             <label style={{ fontSize: 12, fontWeight: 600, color: "var(--ink)", display: "block", marginBottom: 5 }}>{label}</label>
//             <input type={type} value={f[key]} onChange={e => upd(key)(e.target.value)} placeholder={placeholder}
//               style={{ width: "100%", padding: "10px 12px", borderRadius: 8, fontSize: 13, border: `1.5px solid ${errors[key] ? "#fca5a5" : "var(--ln)"}`, outline: "none", background: "#fafafa", boxSizing: "border-box", color: "var(--ink)" }} />
//             {errors[key] && <div style={{ fontSize: 11, color: "#dc2626", marginTop: 4 }}>{errors[key]}</div>}
//           </div>
//         ))}

//         {[
//           { key: "condo_code",     label: "Condo Code",     regen: regenCondo },
//           { key: "hoa_admin_code", label: "HOA Admin Code", regen: regenHoa },
//         ].map(({ key, label, regen }) => (
//           <div key={key} style={{ marginBottom: 14 }}>
//             <label style={{ fontSize: 12, fontWeight: 600, color: "var(--ink)", display: "block", marginBottom: 5 }}>
//               {label} <span style={{ fontWeight: 400, color: "var(--mut)" }}>{isEdit ? "(regenerate only if needed)" : "(auto-generated)"}</span>
//             </label>
//             <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//               <div style={{ flex: 1, padding: "10px 12px", borderRadius: 8, fontSize: 13, border: "1.5px solid var(--ln)", background: "var(--g50)", color: "var(--g700)", fontWeight: 600, letterSpacing: "1px", fontFamily: "monospace" }}>{f[key]}</div>
//               <button onClick={regen} style={{ padding: "9px 11px", borderRadius: 8, border: "1.5px solid var(--ln)", background: "#fff", cursor: "pointer", color: "var(--mut)", display: "flex", alignItems: "center" }}><RefreshCw size={14} /></button>
//               <CopyBtn value={f[key]} />
//             </div>
//           </div>
//         ))}

//         <div style={{ display: "flex", gap: 10, marginTop: 22 }}>
//           <button onClick={onClose} style={{ flex: 1, padding: "11px", borderRadius: 10, border: "1.5px solid var(--ln)", background: "#fff", cursor: "pointer", fontSize: 13, fontWeight: 600, color: "var(--mut)" }}>Cancel</button>
//           <button onClick={submit} disabled={loading} style={{ flex: 2, padding: "11px", borderRadius: 10, border: "none", background: loading ? "var(--g300)" : "var(--g600)", cursor: loading ? "not-allowed" : "pointer", fontSize: 13, fontWeight: 700, color: "#fff" }}>
//             {loading ? "Saving…" : isEdit ? "Save Changes" : "Create Property"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ─── Property Row ─────────────────────────────────────────────────────────────
// function PropertyRow({ prop, onToggle, onEdit, onReset }) {
//   const [expanded,      setExpanded]      = useState(false);
//   const [toggling,      setToggling]      = useState(false);
//   const [resetting,     setResetting]     = useState(false);
//   const [confirmToggle, setConfirmToggle] = useState(false);
//   const [confirmReset,  setConfirmReset]  = useState(false);
//   const [resetMsg,      setResetMsg]      = useState("");

//   const handleToggleConfirmed = async () => {
//     setConfirmToggle(false); setToggling(true);
//     await onToggle(prop.id, !prop.is_active);
//     setToggling(false);
//   };

//   const handleResetConfirmed = async () => {
//     setConfirmReset(false); setResetting(true); setResetMsg("");
//     const result = await onReset(prop.id, prop.name);
//     setResetMsg(result.success ? "✓ Route reset for today" : `Error: ${result.error}`);
//     setResetting(false);
//     setTimeout(() => setResetMsg(""), 4000);
//   };

//   return (
//     <>
//       <div style={{
//         background: "#fff", borderRadius: 12,
//         border: `1.5px solid ${prop.is_active ? "var(--ln)" : "#fecaca"}`,
//         marginBottom: 10, overflow: "hidden",
//         boxShadow: "0 1px 4px rgba(0,0,0,.04)",
//         opacity: prop.is_active ? 1 : 0.78,
//         transition: "opacity .2s",
//       }}>
//         {/* Row Header */}
//         <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 18px", cursor: "pointer" }} onClick={() => setExpanded(p => !p)}>
//           <div style={{ width: 36, height: 36, borderRadius: 10, background: prop.is_active ? "var(--g50)" : "#fef2f2", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
//             <Building2 size={17} color={prop.is_active ? "var(--g600)" : "#dc2626"} />
//           </div>
//           <div style={{ flex: 1, minWidth: 0 }}>
//             <div style={{ fontSize: 14, fontWeight: 700, color: "var(--ink)", marginBottom: 2 }}>{prop.name}</div>
//             <div style={{ fontSize: 12, color: "var(--mut)" }}>{prop.total_units} units{prop.address ? ` · ${prop.address}` : ""}</div>
//           </div>

//           <Badge active={prop.is_active} />

//           {/* Edit */}
//           <button onClick={e => { e.stopPropagation(); onEdit(prop); }} title="Edit property" style={{ background: "none", border: "1.5px solid var(--ln)", borderRadius: 8, cursor: "pointer", color: "var(--mut)", padding: "5px 8px", display: "flex", alignItems: "center" }}>
//             <Pencil size={14} />
//           </button>

//           {/* Toggle */}
//           <button onClick={e => { e.stopPropagation(); setConfirmToggle(true); }} disabled={toggling} title={prop.is_active ? "Deactivate" : "Activate"} style={{ background: "none", border: "none", cursor: toggling ? "not-allowed" : "pointer", color: prop.is_active ? "var(--g600)" : "#dc2626", padding: "2px 4px" }}>
//             {toggling ? <RefreshCw size={17} style={{ animation: "spin 1s linear infinite" }} /> : prop.is_active ? <ToggleRight size={22} /> : <ToggleLeft size={22} />}
//           </button>

//           {expanded ? <ChevronUp size={16} color="var(--mut)" /> : <ChevronDown size={16} color="var(--mut)" />}
//         </div>

//         {/* Expanded Details */}
//         {expanded && (
//           <div style={{ borderTop: "1px solid var(--ln)", padding: "14px 18px", background: "#fafafa" }}>
//             <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 12, marginBottom: 16 }}>
//               {[
//                 { label: "Condo Code",     value: prop.condo_code,     copy: true },
//                 { label: "HOA Admin Code", value: prop.hoa_admin_code, copy: true },
//                 { label: "Property ID",    value: prop.id,             copy: false },
//                 { label: "Created",        value: new Date(prop.created_at).toLocaleDateString(), copy: false },
//               ].map(({ label, value, copy }) => (
//                 <div key={label}>
//                   <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "1px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 4 }}>{label}</div>
//                   <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
//                     <span style={{ fontSize: 12, fontFamily: "monospace", color: "var(--ink)", fontWeight: 600, wordBreak: "break-all" }}>{value}</span>
//                     {copy && <CopyBtn value={value} />}
//                   </div>
//                 </div>
//               ))}
//             </div>

//             {/* ── Reset Daily Route ── */}
//             <div style={{ borderTop: "1px solid var(--ln)", paddingTop: 14, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
//               <div>
//                 <div style={{ fontSize: 12, fontWeight: 700, color: "var(--ink)", marginBottom: 2 }}>Reset Daily Route</div>
//                 <div style={{ fontSize: 11.5, color: "var(--mut)" }}>
//                   Clears today's valet status so the same property and valet code can be reused for the next service.
//                 </div>
//               </div>
//               <div style={{ display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }}>
//                 {resetMsg && (
//                   <span style={{ fontSize: 12, color: resetMsg.startsWith("✓") ? "var(--g600)" : "#dc2626", fontWeight: 600 }}>{resetMsg}</span>
//                 )}
//                 <button
//                   onClick={e => { e.stopPropagation(); setConfirmReset(true); }}
//                   disabled={resetting}
//                   style={{
//                     display: "flex", alignItems: "center", gap: 6,
//                     padding: "8px 16px", borderRadius: 8, border: "1.5px solid #ffb74d",
//                     background: "#fff3e0", color: "#e65100",
//                     fontSize: 12, fontWeight: 700, cursor: resetting ? "not-allowed" : "pointer",
//                     opacity: resetting ? 0.6 : 1,
//                   }}
//                 >
//                   {resetting
//                     ? <RefreshCw size={13} style={{ animation: "spin 1s linear infinite" }} />
//                     : <RotateCcw size={13} />
//                   }
//                   Reset Daily Route
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Confirm Toggle */}
//       {confirmToggle && (
//         <ConfirmDialog
//           title={prop.is_active ? "Deactivate Property?" : "Activate Property?"}
//           message={prop.is_active ? `"${prop.name}" will be deactivated. Valets and residents will lose access.` : `"${prop.name}" will be reactivated.`}
//           confirmLabel={prop.is_active ? "Deactivate" : "Activate"}
//           confirmColor={prop.is_active ? "#dc2626" : "var(--g600)"}
//           onConfirm={handleToggleConfirmed}
//           onCancel={() => setConfirmToggle(false)}
//         />
//       )}

//       {/* Confirm Reset */}
//       {confirmReset && (
//         <ConfirmDialog
//           title="Reset Daily Route?"
//           message={`This will clear today's valet status for "${prop.name}". The valet can start a fresh service run for the same day. Activity logs will not be deleted.`}
//           confirmLabel="Reset Route"
//           confirmColor="#e65100"
//           onConfirm={handleResetConfirmed}
//           onCancel={() => setConfirmReset(false)}
//         />
//       )}
//     </>
//   );
// }

// // ─── Main Page ────────────────────────────────────────────────────────────────
// export default function SuperAdminProperties() {
//   const [properties, setProperties] = useState([]);
//   const [loading,    setLoading]    = useState(true);
//   const [showModal,  setShowModal]  = useState(false);
//   const [editProp,   setEditProp]   = useState(null);
//   const [search,     setSearch]     = useState("");
//   const [filter,     setFilter]     = useState("all");

//   const fetchProperties = async () => {
//     setLoading(true);
//     const { data, error } = await supabase.from("properties").select("*").order("created_at", { ascending: false });
//     if (!error) setProperties(data || []);
//     setLoading(false);
//   };

//   useEffect(() => { fetchProperties(); }, []);

//   const handleToggle = async (id, newStatus) => {
//     await supabase.from("properties").update({ is_active: newStatus, updated_at: new Date() }).eq("id", id);
//     fetchProperties();
//   };

//   // ── Reset Daily Route ──
//   const handleReset = async (propertyId, propertyName) => {
//     const today = getToday();
//     try {
//       // Delete today's valet_status record for this property
//       const { error } = await supabase
//         .from("valet_status")
//         .delete()
//         .eq("property_id", propertyId)
//         .eq("service_date", today);

//       if (error) throw error;

//       // Log the reset in activity_logs
//       await supabase.from("activity_logs").insert({
//         property_id: propertyId,
//         action:      "valet_route_reset",
//         metadata:    { property_name: propertyName, reset_date: today, reset_by: "super_admin" },
//       });

//       return { success: true };
//     } catch (err) {
//       return { success: false, error: err.message };
//     }
//   };

//   const filtered = properties.filter(p => {
//     const matchSearch = p.name.toLowerCase().includes(search.toLowerCase()) || (p.address || "").toLowerCase().includes(search.toLowerCase());
//     const matchFilter = filter === "all" ? true : filter === "active" ? p.is_active : !p.is_active;
//     return matchSearch && matchFilter;
//   });

//   return (
//     <DashboardLayout role="super_admin" title="Property Management" navItems={NAV}>

//       {/* Header */}
//       <div className="fu" style={{ marginBottom: 24 }}>
//         <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "#6a1b9a", marginBottom: 6 }}>Super Admin</div>
//         <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
//           <div>
//             <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, fontWeight: 500, color: "var(--ink)", margin: 0 }}>Properties</h2>
//             <p style={{ fontSize: 13, color: "var(--mut)", marginTop: 4 }}>
//               {properties.length} total · {properties.filter(p => p.is_active).length} active
//             </p>
//           </div>
//           <button onClick={() => setShowModal(true)} style={{ display: "flex", alignItems: "center", gap: 7, padding: "10px 18px", borderRadius: 10, border: "none", background: "var(--g600)", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer", boxShadow: "0 2px 8px rgba(34,107,65,.25)" }}>
//             <Plus size={15} /> Add Property
//           </button>
//         </div>
//       </div>

//       {/* Search + Filter */}
//       <div className="fu d1" style={{ display: "flex", gap: 10, marginBottom: 18, flexWrap: "wrap" }}>
//         <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search properties…"
//           style={{ flex: 1, minWidth: 180, padding: "9px 13px", borderRadius: 8, fontSize: 13, border: "1.5px solid var(--ln)", background: "#fafafa", outline: "none", color: "var(--ink)" }} />
//         {["all", "active", "inactive"].map(f => (
//           <button key={f} onClick={() => setFilter(f)} style={{ padding: "9px 16px", borderRadius: 8, border: "1.5px solid var(--ln)", background: filter === f ? "var(--g600)" : "#fff", color: filter === f ? "#fff" : "var(--mut)", fontSize: 12, fontWeight: 700, cursor: "pointer", textTransform: "capitalize" }}>{f}</button>
//         ))}
//       </div>

//       {/* List */}
//       {loading ? (
//         <div style={{ textAlign: "center", padding: "48px 0", color: "var(--mut)", fontSize: 13 }}>Loading properties…</div>
//       ) : filtered.length === 0 ? (
//         <div style={{ textAlign: "center", padding: "48px 24px", background: "#fff", borderRadius: 14, border: "1.5px dashed var(--ln)" }}>
//           <Building2 size={32} color="var(--ln)" style={{ marginBottom: 12 }} />
//           <div style={{ fontSize: 14, fontWeight: 600, color: "var(--ink)", marginBottom: 6 }}>{search ? "No properties match your search" : "No properties yet"}</div>
//           <div style={{ fontSize: 13, color: "var(--mut)" }}>{!search && "Click 'Add Property' to create your first one."}</div>
//         </div>
//       ) : (
//         filtered.map(prop => (
//           <PropertyRow key={prop.id} prop={prop} onToggle={handleToggle} onEdit={p => setEditProp(p)} onReset={handleReset} />
//         ))
//       )}

//       {showModal && <PropertyModal onClose={() => setShowModal(false)} onSaved={fetchProperties} />}
//       {editProp  && <PropertyModal existing={editProp} onClose={() => setEditProp(null)} onSaved={fetchProperties} />}

//       <style>{`
//         @keyframes fadeUp { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }
//         @keyframes spin   { to { transform:rotate(360deg); } }
//       `}</style>
//     </DashboardLayout>
//   );
// }



import { useState, useEffect } from "react";
import {
  Building2, Plus, ToggleLeft, ToggleRight,
  Copy, Check, RefreshCw, ChevronDown, ChevronUp, X, Pencil, AlertTriangle, RotateCcw, Clock
} from "lucide-react";
import DashboardLayout from "../../../components/DashboardLayout";
import { LayoutDashboard, Users, Key, ScrollText } from "lucide-react";
import { supabase } from "../../../lib/supabaseClient";

const NAV = [
  { label: "Dashboard",     icon: LayoutDashboard, path: "/admin/dashboard" },
  { label: "Properties",    icon: Building2,        path: "/admin/properties" },
  { label: "Users",         icon: Users,            path: "/admin/users" },
  { label: "Valet Codes",   icon: Key,              path: "/admin/valet-codes" },
  { label: "Activity Logs", icon: ScrollText,       path: "/admin/logs" },
];

// ─── Helpers ──────────────────────────────────────────────────────────────────
function genCode(prefix, len = 6) {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  let out = prefix + "-";
  for (let i = 0; i < len; i++) out += chars[Math.floor(Math.random() * chars.length)];
  return out;
}

function getToday() {
  return new Date().toISOString().split("T")[0];
}

function formatTime12(timeStr) {
  if (!timeStr) return null;
  const [h, m] = timeStr.split(":").map(Number);
  const ampm = h >= 12 ? "PM" : "AM";
  const hour  = h % 12 || 12;
  return `${hour}:${String(m).padStart(2, "0")} ${ampm}`;
}

function CopyBtn({ value }) {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };
  return (
    <button onClick={copy} style={{ background: "none", border: "none", cursor: "pointer", color: copied ? "var(--g600)" : "var(--mut)", padding: "2px 4px", borderRadius: 4, display: "inline-flex", alignItems: "center" }}>
      {copied ? <Check size={13} /> : <Copy size={13} />}
    </button>
  );
}

function Badge({ active }) {
  return (
    <span style={{
      fontSize: 10, fontWeight: 700, letterSpacing: ".5px", textTransform: "uppercase",
      padding: "3px 10px", borderRadius: 20,
      background: active ? "var(--g50)" : "#fef2f2",
      color: active ? "var(--g600)" : "#dc2626",
      border: `1px solid ${active ? "var(--g200)" : "#fecaca"}`,
    }}>
      {active ? "Active" : "Inactive"}
    </span>
  );
}

// ─── Confirm Dialog ───────────────────────────────────────────────────────────
function ConfirmDialog({ title, message, confirmLabel, confirmColor = "#dc2626", onConfirm, onCancel }) {
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1100, padding: 16 }}>
      <div style={{ background: "#fff", borderRadius: 14, padding: 24, width: "100%", maxWidth: 360, boxShadow: "0 8px 40px rgba(0,0,0,.16)", animation: "fadeUp .18s ease" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
          <div style={{ width: 38, height: 38, borderRadius: 10, background: "#fef2f2", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <AlertTriangle size={18} color="#dc2626" />
          </div>
          <div style={{ fontSize: 15, fontWeight: 700, color: "var(--ink)" }}>{title}</div>
        </div>
        <div style={{ fontSize: 13, color: "var(--mut)", lineHeight: 1.6, marginBottom: 20 }}>{message}</div>
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={onCancel} style={{ flex: 1, padding: "10px", borderRadius: 9, border: "1.5px solid var(--ln)", background: "#fff", cursor: "pointer", fontSize: 13, fontWeight: 600, color: "var(--mut)" }}>Cancel</button>
          <button onClick={onConfirm} style={{ flex: 1, padding: "10px", borderRadius: 9, border: "none", background: confirmColor, cursor: "pointer", fontSize: 13, fontWeight: 700, color: "#fff" }}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}

// ─── Property Form Modal ──────────────────────────────────────────────────────
function PropertyModal({ existing, onClose, onSaved }) {
  const isEdit = !!existing;

  const [f, setF] = useState({
    name:                   existing?.name                   || "",
    address:                existing?.address                || "",
    total_units:            existing?.total_units            || "",
    condo_code:             existing?.condo_code             || genCode("CAN"),
    hoa_admin_code:         existing?.hoa_admin_code         || genCode("HOA"),
    service_window_start:   existing?.service_window_start   || "",
    service_window_end:     existing?.service_window_end     || "",
  });
  const [errors,  setErrors]  = useState({});
  const [loading, setLoading] = useState(false);
  const [apiErr,  setApiErr]  = useState("");

  const upd = k => v => { setF(p => ({ ...p, [k]: v })); setErrors(p => ({ ...p, [k]: "" })); };
  const regenCondo = () => setF(p => ({ ...p, condo_code: genCode("CAN") }));
  const regenHoa   = () => setF(p => ({ ...p, hoa_admin_code: genCode("HOA") }));

  const validate = () => {
    const e = {};
    if (!f.name.trim()) e.name = "Property name required";
    if (!f.total_units || isNaN(Number(f.total_units)) || Number(f.total_units) < 1)
      e.total_units = "Enter a valid number of units";
    return e;
  };

  const submit = async () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    setLoading(true); setApiErr("");

    const payload = {
      name:                   f.name.trim(),
      address:                f.address.trim() || null,
      total_units:            Number(f.total_units),
      condo_code:             f.condo_code,
      hoa_admin_code:         f.hoa_admin_code,
      service_window_start:   f.service_window_start || null,
      service_window_end:     f.service_window_end   || null,
      updated_at:             new Date(),
    };

    let error;
    if (isEdit) {
      ({ error } = await supabase.from("properties").update(payload).eq("id", existing.id));
    } else {
      ({ error } = await supabase.from("properties").insert([{ ...payload, is_active: true }]));
    }

    setLoading(false);
    if (error) { setApiErr(error.message); return; }
    onSaved(); onClose();
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.35)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 16 }}>
      <div style={{ background: "#fff", borderRadius: 16, padding: 28, width: "100%", maxWidth: 460, boxShadow: "0 8px 40px rgba(0,0,0,.14)", animation: "fadeUp .2s ease", maxHeight: "90vh", overflowY: "auto" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 22 }}>
          <div>
            <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "#6a1b9a", marginBottom: 4 }}>Super Admin</div>
            <div style={{ fontSize: 17, fontWeight: 700, color: "var(--ink)" }}>{isEdit ? "Edit Property" : "Add New Property"}</div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--mut)", padding: 4 }}><X size={20} /></button>
        </div>

        {apiErr && (
          <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: "#dc2626", marginBottom: 16 }}>{apiErr}</div>
        )}

        {/* Basic fields */}
        {[
          { key: "name",        label: "Property Name *",    placeholder: "e.g. Sunset Apartments", type: "text" },
          { key: "address",     label: "Address (Optional)", placeholder: "123 Main St, City",      type: "text" },
          { key: "total_units", label: "Total Units *",      placeholder: "e.g. 100",               type: "number" },
        ].map(({ key, label, placeholder, type }) => (
          <div key={key} style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: "var(--ink)", display: "block", marginBottom: 5 }}>{label}</label>
            <input type={type} value={f[key]} onChange={e => upd(key)(e.target.value)} placeholder={placeholder}
              style={{ width: "100%", padding: "10px 12px", borderRadius: 8, fontSize: 13, border: `1.5px solid ${errors[key] ? "#fca5a5" : "var(--ln)"}`, outline: "none", background: "#fafafa", boxSizing: "border-box", color: "var(--ink)" }} />
            {errors[key] && <div style={{ fontSize: 11, color: "#dc2626", marginTop: 4 }}>{errors[key]}</div>}
          </div>
        ))}

        {/* ── Service Window ── */}
        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 12, fontWeight: 600, color: "var(--ink)", display: "block", marginBottom: 5 }}>
            Service Window <span style={{ fontWeight: 400, color: "var(--mut)" }}>(Optional — shown to residents)</span>
          </label>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div>
              <label style={{ fontSize: 11, color: "var(--mut)", display: "block", marginBottom: 4 }}>Start Time</label>
              <input type="time" value={f.service_window_start} onChange={e => upd("service_window_start")(e.target.value)}
                style={{ width: "100%", padding: "10px 12px", borderRadius: 8, fontSize: 13, border: "1.5px solid var(--ln)", outline: "none", background: "#fafafa", boxSizing: "border-box", color: "var(--ink)" }} />
            </div>
            <div>
              <label style={{ fontSize: 11, color: "var(--mut)", display: "block", marginBottom: 4 }}>End Time</label>
              <input type="time" value={f.service_window_end} onChange={e => upd("service_window_end")(e.target.value)}
                style={{ width: "100%", padding: "10px 12px", borderRadius: 8, fontSize: 13, border: "1.5px solid var(--ln)", outline: "none", background: "#fafafa", boxSizing: "border-box", color: "var(--ink)" }} />
            </div>
          </div>
          {(f.service_window_start || f.service_window_end) && (
            <div style={{ marginTop: 6, fontSize: 11.5, color: "var(--g600)", display: "flex", alignItems: "center", gap: 5 }}>
              <Clock size={11} />
              Residents will see: <strong style={{ marginLeft: 3 }}>
                {formatTime12(f.service_window_start) || "—"}{f.service_window_end ? ` – ${formatTime12(f.service_window_end)}` : ""}
              </strong>
            </div>
          )}
        </div>

        {/* Code fields */}
        {[
          { key: "condo_code",     label: "Condo Code",     regen: regenCondo },
          { key: "hoa_admin_code", label: "HOA Admin Code", regen: regenHoa },
        ].map(({ key, label, regen }) => (
          <div key={key} style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: "var(--ink)", display: "block", marginBottom: 5 }}>
              {label} <span style={{ fontWeight: 400, color: "var(--mut)" }}>{isEdit ? "(regenerate only if needed)" : "(auto-generated)"}</span>
            </label>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ flex: 1, padding: "10px 12px", borderRadius: 8, fontSize: 13, border: "1.5px solid var(--ln)", background: "var(--g50)", color: "var(--g700)", fontWeight: 600, letterSpacing: "1px", fontFamily: "monospace" }}>{f[key]}</div>
              <button onClick={regen} style={{ padding: "9px 11px", borderRadius: 8, border: "1.5px solid var(--ln)", background: "#fff", cursor: "pointer", color: "var(--mut)", display: "flex", alignItems: "center" }}><RefreshCw size={14} /></button>
              <CopyBtn value={f[key]} />
            </div>
          </div>
        ))}

        <div style={{ display: "flex", gap: 10, marginTop: 22 }}>
          <button onClick={onClose} style={{ flex: 1, padding: "11px", borderRadius: 10, border: "1.5px solid var(--ln)", background: "#fff", cursor: "pointer", fontSize: 13, fontWeight: 600, color: "var(--mut)" }}>Cancel</button>
          <button onClick={submit} disabled={loading} style={{ flex: 2, padding: "11px", borderRadius: 10, border: "none", background: loading ? "var(--g300)" : "var(--g600)", cursor: loading ? "not-allowed" : "pointer", fontSize: 13, fontWeight: 700, color: "#fff" }}>
            {loading ? "Saving…" : isEdit ? "Save Changes" : "Create Property"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Property Row ─────────────────────────────────────────────────────────────
function PropertyRow({ prop, onToggle, onEdit, onReset }) {
  const [expanded,      setExpanded]      = useState(false);
  const [toggling,      setToggling]      = useState(false);
  const [resetting,     setResetting]     = useState(false);
  const [confirmToggle, setConfirmToggle] = useState(false);
  const [confirmReset,  setConfirmReset]  = useState(false);
  const [resetMsg,      setResetMsg]      = useState("");

  const handleToggleConfirmed = async () => {
    setConfirmToggle(false); setToggling(true);
    await onToggle(prop.id, !prop.is_active);
    setToggling(false);
  };

  const handleResetConfirmed = async () => {
    setConfirmReset(false); setResetting(true); setResetMsg("");
    const result = await onReset(prop.id, prop.name);
    setResetMsg(result.success ? "✓ Route reset for today" : `Error: ${result.error}`);
    setResetting(false);
    setTimeout(() => setResetMsg(""), 4000);
  };

  return (
    <>
      <div style={{
        background: "#fff", borderRadius: 12,
        border: `1.5px solid ${prop.is_active ? "var(--ln)" : "#fecaca"}`,
        marginBottom: 10, overflow: "hidden",
        boxShadow: "0 1px 4px rgba(0,0,0,.04)",
        opacity: prop.is_active ? 1 : 0.78,
        transition: "opacity .2s",
      }}>
        {/* Row Header */}
        <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 18px", cursor: "pointer" }} onClick={() => setExpanded(p => !p)}>
          <div style={{ width: 36, height: 36, borderRadius: 10, background: prop.is_active ? "var(--g50)" : "#fef2f2", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <Building2 size={17} color={prop.is_active ? "var(--g600)" : "#dc2626"} />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: "var(--ink)", marginBottom: 2 }}>{prop.name}</div>
            <div style={{ fontSize: 12, color: "var(--mut)" }}>
              {prop.total_units} units{prop.address ? ` · ${prop.address}` : ""}
              {(prop.service_window_start || prop.service_window_end) && (
                <span style={{ marginLeft: 8, color: "var(--g600)", fontWeight: 600 }}>
                  · 🕐 {formatTime12(prop.service_window_start) || "—"}{prop.service_window_end ? ` – ${formatTime12(prop.service_window_end)}` : ""}
                </span>
              )}
            </div>
          </div>

          <Badge active={prop.is_active} />

          <button onClick={e => { e.stopPropagation(); onEdit(prop); }} title="Edit property" style={{ background: "none", border: "1.5px solid var(--ln)", borderRadius: 8, cursor: "pointer", color: "var(--mut)", padding: "5px 8px", display: "flex", alignItems: "center" }}>
            <Pencil size={14} />
          </button>

          <button onClick={e => { e.stopPropagation(); setConfirmToggle(true); }} disabled={toggling} title={prop.is_active ? "Deactivate" : "Activate"} style={{ background: "none", border: "none", cursor: toggling ? "not-allowed" : "pointer", color: prop.is_active ? "var(--g600)" : "#dc2626", padding: "2px 4px" }}>
            {toggling ? <RefreshCw size={17} style={{ animation: "spin 1s linear infinite" }} /> : prop.is_active ? <ToggleRight size={22} /> : <ToggleLeft size={22} />}
          </button>

          {expanded ? <ChevronUp size={16} color="var(--mut)" /> : <ChevronDown size={16} color="var(--mut)" />}
        </div>

        {/* Expanded Details */}
        {expanded && (
          <div style={{ borderTop: "1px solid var(--ln)", padding: "14px 18px", background: "#fafafa" }}>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 12, marginBottom: 16 }}>
              {[
                { label: "Condo Code",     value: prop.condo_code,     copy: true },
                { label: "HOA Admin Code", value: prop.hoa_admin_code, copy: true },
                { label: "Property ID",    value: prop.id,             copy: false },
                { label: "Created",        value: new Date(prop.created_at).toLocaleDateString(), copy: false },
              ].map(({ label, value, copy }) => (
                <div key={label}>
                  <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "1px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 4 }}>{label}</div>
                  <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                    <span style={{ fontSize: 12, fontFamily: "monospace", color: "var(--ink)", fontWeight: 600, wordBreak: "break-all" }}>{value}</span>
                    {copy && <CopyBtn value={value} />}
                  </div>
                </div>
              ))}
            </div>

            {/* ── Service Window Display ── */}
            <div style={{ borderTop: "1px solid var(--ln)", paddingTop: 14, marginBottom: 14 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: "var(--ink)", marginBottom: 2, display: "flex", alignItems: "center", gap: 6 }}>
                    <Clock size={13} color="var(--g600)" /> Service Window
                  </div>
                  <div style={{ fontSize: 11.5, color: "var(--mut)" }}>
                    {(prop.service_window_start || prop.service_window_end)
                      ? <span style={{ color: "var(--g700)", fontWeight: 600 }}>
                          {formatTime12(prop.service_window_start) || "—"}
                          {prop.service_window_end ? ` – ${formatTime12(prop.service_window_end)}` : ""}
                        </span>
                      : "Not set — click Edit to add a service window."
                    }
                  </div>
                </div>
                <button onClick={e => { e.stopPropagation(); onEdit(prop); }} style={{
                  display: "flex", alignItems: "center", gap: 5,
                  padding: "6px 14px", borderRadius: 7, border: "1.5px solid var(--g200)",
                  background: "var(--g50)", color: "var(--g700)",
                  fontSize: 11.5, fontWeight: 700, cursor: "pointer",
                }}>
                  <Pencil size={11} /> Edit Window
                </button>
              </div>
            </div>

            {/* ── Reset Daily Route ── */}
            <div style={{ borderTop: "1px solid var(--ln)", paddingTop: 14, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
              <div>
                <div style={{ fontSize: 12, fontWeight: 700, color: "var(--ink)", marginBottom: 2 }}>Reset Daily Route</div>
                <div style={{ fontSize: 11.5, color: "var(--mut)" }}>
                  Clears today's valet status so the same property and valet code can be reused.
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }}>
                {resetMsg && (
                  <span style={{ fontSize: 12, color: resetMsg.startsWith("✓") ? "var(--g600)" : "#dc2626", fontWeight: 600 }}>{resetMsg}</span>
                )}
                <button
                  onClick={e => { e.stopPropagation(); setConfirmReset(true); }}
                  disabled={resetting}
                  style={{
                    display: "flex", alignItems: "center", gap: 6,
                    padding: "8px 16px", borderRadius: 8, border: "1.5px solid #ffb74d",
                    background: "#fff3e0", color: "#e65100",
                    fontSize: 12, fontWeight: 700, cursor: resetting ? "not-allowed" : "pointer",
                    opacity: resetting ? 0.6 : 1,
                  }}
                >
                  {resetting ? <RefreshCw size={13} style={{ animation: "spin 1s linear infinite" }} /> : <RotateCcw size={13} />}
                  Reset Daily Route
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {confirmToggle && (
        <ConfirmDialog
          title={prop.is_active ? "Deactivate Property?" : "Activate Property?"}
          message={prop.is_active ? `"${prop.name}" will be deactivated. Valets and residents will lose access.` : `"${prop.name}" will be reactivated.`}
          confirmLabel={prop.is_active ? "Deactivate" : "Activate"}
          confirmColor={prop.is_active ? "#dc2626" : "var(--g600)"}
          onConfirm={handleToggleConfirmed}
          onCancel={() => setConfirmToggle(false)}
        />
      )}

      {confirmReset && (
        <ConfirmDialog
          title="Reset Daily Route?"
          message={`This will clear today's valet status for "${prop.name}". The valet can start a fresh service run. Activity logs will not be deleted.`}
          confirmLabel="Reset Route"
          confirmColor="#e65100"
          onConfirm={handleResetConfirmed}
          onCancel={() => setConfirmReset(false)}
        />
      )}
    </>
  );
}

// ─── Main Page ────────────────────────────────────────────────────────────────
export default function SuperAdminProperties() {
  const [properties, setProperties] = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [showModal,  setShowModal]  = useState(false);
  const [editProp,   setEditProp]   = useState(null);
  const [search,     setSearch]     = useState("");
  const [filter,     setFilter]     = useState("all");

  const fetchProperties = async () => {
    setLoading(true);
    const { data, error } = await supabase.from("properties").select("*").order("created_at", { ascending: false });
    if (!error) setProperties(data || []);
    setLoading(false);
  };

  useEffect(() => { fetchProperties(); }, []);

  const handleToggle = async (id, newStatus) => {
    await supabase.from("properties").update({ is_active: newStatus, updated_at: new Date() }).eq("id", id);
    fetchProperties();
  };

  const handleReset = async (propertyId, propertyName) => {
    const today = getToday();
    try {
      const { error } = await supabase.from("valet_status").delete().eq("property_id", propertyId).eq("service_date", today);
      if (error) throw error;
      await supabase.from("activity_logs").insert({
        property_id: propertyId,
        action:      "valet_route_reset",
        metadata:    { property_name: propertyName, reset_date: today, reset_by: "super_admin" },
      });
      return { success: true };
    } catch (err) {
      return { success: false, error: err.message };
    }
  };

  const filtered = properties.filter(p => {
    const matchSearch = p.name.toLowerCase().includes(search.toLowerCase()) || (p.address || "").toLowerCase().includes(search.toLowerCase());
    const matchFilter = filter === "all" ? true : filter === "active" ? p.is_active : !p.is_active;
    return matchSearch && matchFilter;
  });

  return (
    <DashboardLayout role="super_admin" title="Property Management" navItems={NAV}>

      {/* Header */}
      <div className="fu" style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "#6a1b9a", marginBottom: 6 }}>Super Admin</div>
        <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
          <div>
            <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, fontWeight: 500, color: "var(--ink)", margin: 0 }}>Properties</h2>
            <p style={{ fontSize: 13, color: "var(--mut)", marginTop: 4 }}>
              {properties.length} total · {properties.filter(p => p.is_active).length} active
            </p>
          </div>
          <button onClick={() => setShowModal(true)} style={{ display: "flex", alignItems: "center", gap: 7, padding: "10px 18px", borderRadius: 10, border: "none", background: "var(--g600)", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer", boxShadow: "0 2px 8px rgba(34,107,65,.25)" }}>
            <Plus size={15} /> Add Property
          </button>
        </div>
      </div>

      {/* Search + Filter */}
      <div className="fu d1" style={{ display: "flex", gap: 10, marginBottom: 18, flexWrap: "wrap" }}>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search properties…"
          style={{ flex: 1, minWidth: 180, padding: "9px 13px", borderRadius: 8, fontSize: 13, border: "1.5px solid var(--ln)", background: "#fafafa", outline: "none", color: "var(--ink)" }} />
        {["all", "active", "inactive"].map(f => (
          <button key={f} onClick={() => setFilter(f)} style={{ padding: "9px 16px", borderRadius: 8, border: "1.5px solid var(--ln)", background: filter === f ? "var(--g600)" : "#fff", color: filter === f ? "#fff" : "var(--mut)", fontSize: 12, fontWeight: 700, cursor: "pointer", textTransform: "capitalize" }}>{f}</button>
        ))}
      </div>

      {/* List */}
      {loading ? (
        <div style={{ textAlign: "center", padding: "48px 0", color: "var(--mut)", fontSize: 13 }}>Loading properties…</div>
      ) : filtered.length === 0 ? (
        <div style={{ textAlign: "center", padding: "48px 24px", background: "#fff", borderRadius: 14, border: "1.5px dashed var(--ln)" }}>
          <Building2 size={32} color="var(--ln)" style={{ marginBottom: 12 }} />
          <div style={{ fontSize: 14, fontWeight: 600, color: "var(--ink)", marginBottom: 6 }}>{search ? "No properties match your search" : "No properties yet"}</div>
          <div style={{ fontSize: 13, color: "var(--mut)" }}>{!search && "Click 'Add Property' to create your first one."}</div>
        </div>
      ) : (
        filtered.map(prop => (
          <PropertyRow key={prop.id} prop={prop} onToggle={handleToggle} onEdit={p => setEditProp(p)} onReset={handleReset} />
        ))
      )}

      {showModal && <PropertyModal onClose={() => setShowModal(false)} onSaved={fetchProperties} />}
      {editProp  && <PropertyModal existing={editProp} onClose={() => setEditProp(null)} onSaved={fetchProperties} />}

      <style>{`
        @keyframes fadeUp { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }
        @keyframes spin   { to { transform:rotate(360deg); } }
      `}</style>
    </DashboardLayout>
  );
}